/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 *  Possible values: Unavailable = 0, Available = 1
 */
export enum Routemize_Constants_WorkingHourStatus {
    UNAVAILABLE = 'Unavailable',
    AVAILABLE = 'Available',
}
